/* =====================================================================
   Cave Larégnère — Ajout rapide au panier (autonome, réutilise le panier Eurus).
   N'ouvre PAS de panier parallèle : POST /cart/add.js sur le MÊME panier Shopify,
   puis rafraîchit le compteur (#cart-icon-bubble) et le drawer (#CartDrawer) via la
   Section Rendering API, émet les events Eurus, et affiche une confirmation sobre.
   Délégation d'événements → fonctionne aussi sur les cartes injectées par les filtres.
   ===================================================================== */
(function () {
  'use strict';
  var LIVE = null, TOAST = null;

  function ensureUI() {
    if (!LIVE) {
      LIVE = document.createElement('div');
      LIVE.className = 'cl-visually-hidden';
      LIVE.setAttribute('aria-live', 'polite');
      LIVE.setAttribute('role', 'status');
      document.body.appendChild(LIVE);
    }
    if (!TOAST) {
      TOAST = document.createElement('div');
      TOAST.className = 'cl-toast';
      TOAST.setAttribute('role', 'status');
      document.body.appendChild(TOAST);
    }
  }
  function announce(msg) { ensureUI(); LIVE.textContent = ''; setTimeout(function(){ LIVE.textContent = msg; }, 30); }
  function showToast(html) {
    ensureUI();
    TOAST.innerHTML = html;
    TOAST.classList.add('is-shown');
    clearTimeout(TOAST._t);
    TOAST._t = setTimeout(function () { TOAST.classList.remove('is-shown'); }, 4500);
  }
  function sectionIdOf(sel) {
    var el = document.querySelector(sel);
    if (!el) return null;
    var host = el.closest('[id^="shopify-section-"]');
    return host ? host.id.replace('shopify-section-', '') : null;
  }
  function replaceSection(id, html) {
    if (!id || !html) return;
    var host = document.getElementById('shopify-section-' + id);
    if (!host) return;
    var tmp = document.createElement('div');
    tmp.innerHTML = html;
    var fresh = tmp.querySelector('#shopify-section-' + id);
    host.innerHTML = fresh ? fresh.innerHTML : tmp.innerHTML;
  }
  function setLabel(btn, text) {
    var l = btn.querySelector('.cl-atc__label');
    if (l) l.textContent = text;
  }
  function getLabel(btn) {
    var l = btn.querySelector('.cl-atc__label');
    return l ? l.textContent : 'Ajouter au panier';
  }

  /* Le store panier du thème. Absent tant qu'Alpine n'a pas démarré (ce
     fichier est chargé avant vendors.js), d'où la lecture à chaque clic. */
  function helperPanier() {
    try {
      return (window.Alpine && Alpine.store && Alpine.store('xCartHelper')) || null;
    } catch (e) { return null; }
  }

  function addToCart(btn) {
    if (btn.getAttribute('aria-busy') === 'true') return;
    var id = btn.getAttribute('data-variant-id');
    if (!id) return;
    // Quantité choisie sur la carte, quel que soit le jeu de paliers. Absente ailleurs → 1.
    var qte = parseInt(btn.getAttribute('data-qte'), 10);
    if (!qte || qte < 1 || qte > 99) { qte = 1; }
    var original = getLabel(btn);
    btn.setAttribute('aria-busy', 'true');
    btn.classList.add('is-loading');
    btn.classList.remove('is-error', 'is-added');

    // On demande au thème QUELLES sections rafraîchir, plutôt que de le deviner :
    // c'est le même contrat que son propre formulaire produit.
    var aide = helperPanier();
    var cibles = null;
    try {
      if (aide && typeof aide.getSectionsToRender === 'function') { cibles = aide.getSectionsToRender(); }
    } catch (e) {}
    var bubbleSec = sectionIdOf('#cart-icon-bubble') || sectionIdOf('#mobile-cart-icon-bubble');
    var drawerSec = sectionIdOf('#CartDrawer');
    var sections = cibles && cibles.length
      ? cibles.map(function (s) { return s.id; })
      : [bubbleSec, drawerSec].filter(Boolean);

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(id, 10), quantity: qte }],
        sections: sections,
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, status: r.status, d: d }; }); })
      .then(function (res) {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('is-loading');
        if (!res.ok) { throw new Error((res.d && res.d.description) || 'add_error'); }
        var d = res.d;
        /* Mesure — même convention que le sommelier et l'age-gate :
           dataLayer `cl_quick_add` + CustomEvent. Placée APRÈS le succès et
           enveloppée : une erreur de mesure ne doit jamais casser un ajout. */
        try {
          var charge = {
            outil: 'quick_add',
            produit: (d && d.handle) || '',
            variante: id,
            quantite: qte,
            emplacement: btn.closest('.recipe-products__card, .rmaillage__card') ? 'recette'
                       : (btn.closest('[data-cl-emplacement]') ? btn.closest('[data-cl-emplacement]').getAttribute('data-cl-emplacement')
                       : 'carte')
          };
          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push(Object.assign({ event: 'cl_quick_add' }, charge));
          document.dispatchEvent(new CustomEvent('cl:quick_add', { detail: charge }));
        } catch (e) {}
        btn.classList.add('is-added');
        setLabel(btn, 'Ajouté ✓');
        setTimeout(function () { btn.classList.remove('is-added'); setLabel(btn, original); }, 2200);
        announce('Produit ajouté au panier.');

        // On laisse le thème rafraîchir ses sections. C'est important : sa
        // méthode ne remplace que l'intérieur de `#CartDrawer`, alors que notre
        // repli remplaçait `#shopify-section-cart-drawer` en entier — donc la
        // racine `x-data` du tiroir. Le composant Alpine était détruit puis
        // recréé, et le panier se retrouvait bloqué jusqu'au rechargement.
        var rendu;
        if (aide && typeof aide.reRenderSections === 'function') {
          try { rendu = Promise.resolve(aide.reRenderSections(d.sections)); } catch (e) { rendu = null; }
        }
        if (!rendu) {
          if (d.sections) {
            replaceSection(bubbleSec, d.sections[bubbleSec]);
            replaceSection(drawerSec, d.sections[drawerSec]);
          }
          rendu = Promise.resolve();
        }

        rendu.then(function () {
          try {
            var bulle = document.getElementById('cart-icon-bubble');
            if (aide && bulle) {
              var n = parseInt((bulle.textContent || '').trim(), 10);
              if (!isNaN(n)) { aide.currentItemCount = n; }
            }
          } catch (e) {}
          /* RETIRÉ le 2026-08-07 : l'ouverture automatique du tiroir
             (`Alpine.store('xMiniCart').openCart()`) est le suspect principal du
             panier qui se bloque et n'est récupérable qu'en rechargeant la page.
             Impossible à reproduire côté serveur ; on l'enlève pour l'isoler.
             Le gain qu'elle apportait — montrer le rappel point relais et le
             bouton Commander — ne vaut pas le risque d'un panier inaccessible.
             Ne pas la remettre sans l'avoir testée dans un vrai navigateur. */
          showToast('<span class="cl-toast__ico" aria-hidden="true">✓</span><span class="cl-toast__txt">Ajouté au panier</span><a class="cl-toast__link" href="/cart">Voir le panier</a>');
        });

        try {
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed', { bubbles: true, detail: d }));
          document.dispatchEvent(new CustomEvent('eurus:product:added', { bubbles: true, detail: d }));
        } catch (e) {}
      })
      .catch(function () {
        btn.setAttribute('aria-busy', 'false');
        btn.classList.remove('is-loading');
        btn.classList.add('is-error');
        setLabel(btn, 'Réessayer');
        announce('Une erreur est survenue, veuillez réessayer.');
        setTimeout(function () { btn.classList.remove('is-error'); setLabel(btn, original); }, 2600);
      });
  }

  /* Paliers 1 | 3 | 6 | 12 posés au-dessus du bouton d'achat.
     ---------------------------------------------------------------------
     Le palier ne fait que SÉLECTIONNER : la valeur est reportée sur le bouton
     d'achat voisin via `data-qte`, et c'est « Ajouter au panier » qui ajoute.
     Aucun état conservé ailleurs, donc le rafraîchissement d'une section du
     panier ne peut pas le désynchroniser.

     Le bouton d'achat est cherché en remontant les ancêtres plutôt qu'avec une
     liste de classes de cartes : le composant sert aujourd'hui sur les cartes
     de recette, demain sur les collections et l'aperçu rapide, et cette
     recherche n'a pas à connaître leur balisage. */
  function boutonAchatDe(el) {
    var n = el, atc = null, i = 0;
    while (n && n !== document.body && i < 6) {
      atc = n.querySelector && n.querySelector('.cl-atc[data-variant-id]');
      if (atc) return atc;
      n = n.parentNode; i++;
    }
    return null;
  }

  /* SUR LA FICHE PRODUIT il n'y a pas de bouton `.cl-atc` : la quantité vit dans
     le champ nombre d'Eurus, lié à Alpine par `x-model="qty"`. Écrire `.value`
     ne suffit donc pas — Alpine n'écoute que l'événement `input`. On émet les
     deux (`input` pour Alpine, `change` pour tout écouteur natif), et le pas-à-pas
     « − n + » d'à côté se met à jour tout seul puisqu'il lit la même variable.
     La recherche est bornée au `.x-quantity-selector` qui entoure le groupe :
     sur une carte de collection il n'y en a pas, donc rien ne change là-bas. */
  function champQuantiteDe(groupe) {
    var hote = groupe.closest('.x-quantity-selector');
    return hote ? hote.querySelector('input[name="quantity"]') : null;
  }

  /* `silencieux` : amorçage au chargement. On reporte alors la valeur sur le
     bouton d'ajout de la carte, mais on NE TOUCHE PAS au champ d'Eurus — lui
     seul connaît la quantité minimale du produit (`quantity_rule.min`), et
     l'écraser par 1 avant tout geste du client serait une régression muette.
     Le champ n'est repris qu'à partir du moment où quelqu'un choisit un palier. */
  function choisirPalier(btn, silencieux) {
    var groupe = btn.closest('.cl-qte--paliers');
    if (!groupe) return;
    var n = parseInt(btn.getAttribute('data-qte-palier'), 10) || 1;
    groupe.querySelectorAll('.cl-qte__palier').forEach(function (b) {
      var actif = b === btn;
      b.classList.toggle('is-actif', actif);
      b.setAttribute('aria-pressed', actif ? 'true' : 'false');
    });
    var achat = boutonAchatDe(groupe);
    if (achat) { achat.setAttribute('data-qte', n); }
    if (silencieux) return;
    var champ = champQuantiteDe(groupe);
    if (champ && champ.value !== String(n)) {
      champ.value = n;
      champ.dispatchEvent(new Event('input', { bubbles: true }));
      champ.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  /* La touche « + » déplie les paliers gardés en réserve sur mobile. Elle ne
     charge rien : les sept sont déjà dans le HTML, seul l'affichage change.
     Une fois dépliée, la rangée le reste — on ne referme pas sous les doigts
     de quelqu'un qui vient de chercher son format. */
  function deplier(bouton) {
    var groupe = bouton.closest('.cl-qte--paliers');
    if (!groupe) return;
    groupe.classList.add('est-ouvert');
    bouton.setAttribute('aria-expanded', 'true');
    bouton.setAttribute('aria-label', 'Toutes les quantités sont affichées');
    bouton.textContent = '−';
    /* On donne la main au premier palier révélé : au clavier comme au
       lecteur d'écran, la suite de la rangée doit être immédiate. */
    var premier = groupe.querySelector('.cl-qte__palier--sec:not([disabled])');
    if (premier) { premier.focus(); }
  }

  function replier(bouton) {
    var groupe = bouton.closest('.cl-qte--paliers');
    if (!groupe) return;
    /* Si le palier choisi fait partie des paliers cachés, on ne replie pas :
       masquer la valeur retenue laisserait le client sans repère. */
    var actif = groupe.querySelector('.cl-qte__palier.is-actif');
    if (actif && actif.classList.contains('cl-qte__palier--sec')) return;
    groupe.classList.remove('est-ouvert');
    bouton.setAttribute('aria-expanded', 'false');
    bouton.setAttribute('aria-label', 'Voir toutes les quantités disponibles');
    bouton.textContent = '+';
  }

  document.addEventListener('click', function (e) {
    var plus = e.target.closest('.cl-qte__plus');
    if (plus) {
      e.preventDefault();
      e.stopPropagation();        /* la carte entière est un lien : ne pas naviguer */
      if (plus.getAttribute('aria-expanded') === 'true') { replier(plus); }
      else { deplier(plus); }
      return;
    }
    var palier = e.target.closest('.cl-qte__palier');
    if (!palier || palier.disabled) return;
    e.preventDefault();
    e.stopPropagation();          /* la carte entière est un lien : ne pas naviguer */
    choisirPalier(palier);
  });

  /* Au clavier, ← → circulent entre les paliers comme dans un groupe de radios. */
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    var palier = e.target.closest && e.target.closest('.cl-qte__palier');
    if (!palier) return;
    var tous = Array.prototype.filter.call(
      palier.closest('.cl-qte--paliers').querySelectorAll('.cl-qte__palier'),
      function (b) { return !b.disabled; });
    var i = tous.indexOf(palier);
    var suivant = tous[e.key === 'ArrowRight' ? i + 1 : i - 1];
    if (!suivant) return;
    e.preventDefault();
    suivant.focus();
    choisirPalier(suivant);
  });

  /* Le premier palier actif est déjà marqué en Liquid ; on ne fait que reporter
     sa valeur sur le bouton, au cas où la carte arrive par un rendu de section. */
  function amorcer(racine) {
    (racine || document).querySelectorAll('.cl-qte--paliers').forEach(function (g) {
      var actif = g.querySelector('.cl-qte__palier.is-actif:not([disabled])')
               || g.querySelector('.cl-qte__palier:not([disabled])');
      if (actif) choisirPalier(actif, true);
    });
  }
  document.addEventListener('DOMContentLoaded', function () { amorcer(document); });
  document.addEventListener('shopify:section:load', function (e) { amorcer(e.target); });

  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.cl-atc[data-variant-id]');
    if (!btn) return;
    e.preventDefault();
    e.stopPropagation();
    addToCart(btn);
  });
})();

/* Tiroir de filtres mobile : construction à l'ouverture -----------------------
   Le thème rend chaque valeur de filtre deux fois — barre ordinateur ET tiroir
   mobile. Sur la grande cave cela faisait 594 lignes pour 297 valeurs réelles.
   snippets/input-filter.liquid ne rend plus, côté tiroir, que les valeurs
   actives ; les autres sont recopiées ici depuis la liste de l'ordinateur, à
   l'ouverture du groupe concerné.

   Sur ordinateur, aucun groupe du tiroir n'est ouvert : la liste n'est jamais
   construite, ni en nœuds ni en composants Alpine.

   En cas de pépin (liste source introuvable, erreur de copie), on laisse la
   liste en l'état : les filtres actifs restent affichés et soumis. */
(function () {
  'use strict';

  function hydrater(ul) {
    if (!ul || ul.dataset.clPret) return;
    var cle = ul.getAttribute('data-cl-key');
    if (!cle) return;

    var source = null;
    var listes = document.querySelectorAll('.cl-facet-list[data-cl-key]');
    for (var i = 0; i < listes.length; i++) {
      if (listes[i] !== ul && !listes[i].hasAttribute('data-cl-lazy') &&
          listes[i].getAttribute('data-cl-key') === cle) { source = listes[i]; break; }
    }
    if (!source) return;                 /* pas de source : on ne touche à rien */

    ul.dataset.clPret = '1';

    /* les valeurs déjà présentes (= actives) ne doivent pas être dupliquées */
    var deja = {};
    ul.querySelectorAll('input[type="checkbox"]').forEach(function (i) { deja[i.value] = true; });

    var frag = document.createDocumentFragment();
    source.querySelectorAll('.cl-facet-item').forEach(function (li) {
      var src = li.querySelector('input[type="checkbox"]');
      if (!src || deja[src.value]) return;
      var copie = li.cloneNode(true);
      var inp = copie.querySelector('input[type="checkbox"]');
      var lab = copie.querySelector('label');
      /* les identifiants doivent rester uniques entre les deux formulaires */
      var id = inp.id.replace(/^Filter-(above|aside)-/, 'Filter-drawer-');
      inp.id = id;
      if (lab) lab.setAttribute('for', id);
      inp.checked = false;
      inp.setAttribute('data-cl-clone', '1');
      frag.appendChild(copie);
    });
    ul.appendChild(frag);
  }

  /* Déclencheur principal : l'apparition du tiroir lui-même.
     Se fier au seul clic sur l'en-tête d'un groupe ne suffit pas — un groupe
     peut être déplié d'origine, et l'utilisateur verrait alors une liste vide.
     Dès que le tiroir devient visible, on construit tous ses groupes d'un coup.
     Sur ordinateur le tiroir ne s'affiche jamais : rien n'est construit. */
  function surveillerTiroir() {
    var tiroir = document.querySelector('.form-drawer');
    if (!tiroir || !('IntersectionObserver' in window)) return;
    new IntersectionObserver(function (entrees, obs) {
      entrees.forEach(function (e) {
        if (!e.isIntersecting) return;
        obs.disconnect();
        tiroir.querySelectorAll('.cl-facet-list[data-cl-lazy]').forEach(function (ul) {
          try { hydrater(ul); } catch (err) { /* on laisse la liste telle quelle */ }
        });
      });
    }, { threshold: 0 }).observe(tiroir);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', surveillerTiroir);
  } else {
    surveillerTiroir();
  }
  /* le thème réécrit le tiroir à chaque filtrage : on réarme la surveillance */
  document.addEventListener('eurus:collection:reloaded', surveillerTiroir);

  /* Filets : l'ouverture d'un groupe et la saisie dans la recherche interne.
     On écoute en délégation, le tiroir étant réécrit à chaque filtrage. */
  document.addEventListener('click', function (e) {
    var bouton = e.target.closest('.form-drawer .js-filter > button, .form-drawer .facets__summary');
    if (!bouton) return;
    var groupe = bouton.closest('.js-filter');
    if (!groupe) return;
    try { hydrater(groupe.querySelector('.cl-facet-list[data-cl-lazy]')); }
    catch (err) { /* on laisse la liste telle quelle */ }
  }, true);

  /* Les lignes recopiées portent `@change="onSubmit()"`, une directive Alpine.
     Alpine 3 initialise bien les nœuds ajoutés après coup, mais on ne veut pas
     que le filtrage repose sur cette hypothèse : si la case recopiée change,
     on relaie l'événement sur un champ du même formulaire qu'Alpine a relié au
     chargement (le prix, ou le tri). `onSubmit()` sérialise de toute façon le
     formulaire entier — la case cochée est donc prise en compte — et son
     minuteur interne absorbe un éventuel double appel. */
  document.addEventListener('change', function (e) {
    var i = e.target;
    if (!i || !i.matches || !i.matches('input[data-cl-clone]')) return;
    var form = i.closest('form');
    if (!form) return;
    var relais = form.querySelector('input.price-input') ||
                 form.querySelector('input[\\@change]:not([data-cl-clone])') ||
                 form.querySelector('[x-on\\:change]:not([data-cl-clone])');
    if (relais && relais !== i) {
      relais.dispatchEvent(new Event('change', { bubbles: true }));
      return;
    }
    /* Dernier filet, si le formulaire ne contient aucun champ relié : envoi
       natif. Le formulaire n'a ni action ni method, donc c'est un GET sur
       l'adresse courante avec les filtres cochés — la bonne URL, au prix d'un
       rechargement complet plutôt qu'un rafraîchissement en arrière-plan. */
    if (form.requestSubmit) form.requestSubmit(); else form.submit();
  });

  /* Filet : si le tiroir s'ouvre déjà déplié, on construit à la première frappe
     dans le champ de recherche interne. */
  document.addEventListener('focusin', function (e) {
    var champ = e.target.closest('.form-drawer .cl-facet-search');
    if (!champ) return;
    var groupe = champ.closest('.js-filter');
    if (!groupe) return;
    try { hydrater(groupe.querySelector('.cl-facet-list[data-cl-lazy]')); }
    catch (err) { /* idem */ }
  }, true);
})();

/* Recherche interne dans les longues listes de filtres (Appellation, Producteur…) */
(function () {
  'use strict';
  function norm(s) { return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, ''); }
  document.addEventListener('input', function (e) {
    var input = e.target.closest('.cl-facet-search');
    if (!input) return;
    var wrap = input.closest('.cl-facet-search-wrap');
    var list = wrap && wrap.parentNode.querySelector('.cl-facet-list');
    if (!list) return;
    var q = norm(input.value.trim());
    var shown = 0;
    list.querySelectorAll('.cl-facet-item').forEach(function (li) {
      /* Le libellé est lu dans la ligne elle-même : l'attribut data-label
         dupliquait ce texte sur chaque valeur de filtre (jusqu'à 600 par page).
         On retire le compteur « (12) » de fin pour ne pas chercher sur lui. */
      var lbl = li.getAttribute('data-label') || li.textContent.replace(/\s*\(\d+\)\s*$/, '');
      var match = q === '' || norm(lbl).indexOf(q) > -1;
      li.style.display = match ? '' : 'none';
      if (match) shown++;
    });
    var empty = wrap.querySelector('.cl-facet-search__empty');
    if (empty) empty.hidden = shown !== 0;
  });
})();

/* ==========================================================================
   EN-TÊTE MOBILE ESCAMOTABLE — 2026-08-11
   --------------------------------------------------------------------------
   Mesuré sur capture : la barre du logo et la barre de recherche restent
   collées en haut à tous les niveaux de défilement et occupent ~145 px, soit
   17 % d'un écran d'iPhone qui ne montrent jamais de vin.

   On escamote l'en-tête quand le visiteur descend, on le rend dès qu'il
   remonte — le geste de remontée est justement celui de quelqu'un qui
   cherche à naviguer. Panier et menu restent donc à un geste.

   Vérifié avant d'écrire : le tiroir de menu n'est PAS un descendant de
   `#sticky-header-content`, et ce conteneur n'abrite aucun élément en
   `position: fixed`. Une transformation dessus est donc sans effet de bord —
   ce ne serait pas le cas autrement, un ancêtre transformé devenant le
   référentiel de ses descendants fixes.
   ========================================================================== */
(function () {
  var entete = document.getElementById('sticky-header-content');
  if (!entete || !window.matchMedia) return;
  var petitEcran = window.matchMedia('(max-width: 1023px)');

  var dernier = window.pageYOffset || 0;
  var replie  = false;
  var enAttente = false;
  var largeur = window.innerWidth;
  var verrou = 0;

  /* Seuil de 6 px : en dessous, c'est le tremblement du doigt ou le rebond
     élastique d'iOS, pas une intention de défiler. */
  var SEUIL = 6;
  /* On ne masque jamais dans les 200 premiers pixels : en haut de page,
     l'en-tête fait partie du décor et le masquer donnerait un clignotement. */
  var GARDE = 200;

  function arbitrer() {
    enAttente = false;
    if (!petitEcran.matches) {
      if (replie) { document.documentElement.classList.remove('cl-entete-repliee'); replie = false; }
      return;
    }
    var y = window.pageYOffset || 0;

    /* VERROU — la correction du clignotement filmé sur Android le 10 septembre.
       Replier l'en-tête retire ~65 px de la HAUTEUR DU DOCUMENT, puisque le
       bloc reste dans le flux (`position: sticky`). Le navigateur recale alors
       la position de défilement d'autant pour que le contenu ne saute pas —
       c'est l'ancrage de défilement, actif par défaut sur Chrome. Le calcul
       ci-dessous lisait ce recalage comme un geste de REMONTÉE : l'en-tête se
       rouvrait, le document regrandissait, le recalage repartait en sens
       inverse, et la boucle s'entretenait toute seule à chaque image.
       Pendant la transition (0,22 s) on ne décide donc plus rien : on se
       contente de reprendre le repère là où le navigateur l'a laissé. */
    if (verrou && Date.now() < verrou) { dernier = y; return; }
    verrou = 0;

    var delta = y - dernier;
    if (Math.abs(delta) < SEUIL) return;

    /* Si le visiteur est en train de taper dans la recherche, on ne bouge
       rien sous ses yeux : le clavier virtuel provoque lui-même du
       défilement, et voir le champ disparaître serait déroutant. */
    var actif = document.activeElement;
    var saisieEnCours = actif && entete.contains(actif) &&
      /^(INPUT|TEXTAREA|SELECT)$/.test(actif.tagName);

    var doitReplier = delta > 0 && y > GARDE && !saisieEnCours;
    if (doitReplier !== replie) {
      document.documentElement.classList.toggle('cl-entete-repliee', doitReplier);
      replie = doitReplier;
      /* 380 ms : la transition dure 220 ms, on garde de la marge pour le
         recalage que le navigateur applique une fois la hauteur stabilisée. */
      verrou = Date.now() + 380;
    }
    dernier = y;
  }

  /* Le calcul est repoussé à la prochaine image : on ne fait pas travailler
     le fil principal à chaque pixel de défilement. */
  window.addEventListener('scroll', function () {
    if (enAttente) return;
    enAttente = true;
    window.requestAnimationFrame(arbitrer);
  }, { passive: true });

  /* Retour en haut, changement d'orientation, passage en grand écran :
     dans tous ces cas l'en-tête doit se remontrer. */
  window.addEventListener('resize', function () {
    /* On ne réagit qu'à un changement de LARGEUR. Android fait apparaître et
       disparaître sa barre d'adresse pendant le défilement : c'est un `resize`
       de HAUTEUR seule, plusieurs fois par seconde. Déplier l'en-tête à chaque
       fois relançait le clignotement, en plus de la boucle décrite plus haut.
       La rotation et le passage sur grand écran, eux, changent la largeur —
       ce sont les seuls cas où l'en-tête doit vraiment se remontrer. */
    dernier = window.pageYOffset || 0;
    if (window.innerWidth === largeur) return;
    largeur = window.innerWidth;
    verrou = 0;
    document.documentElement.classList.remove('cl-entete-repliee');
    replie = false;
  }, { passive: true });
})();
